package ui.campaign.detailv2.editor.widget

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.material3.LocalTextStyle
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import provider.LocalDisplayProvider
import ui.widget.Space

@Composable
fun TwoFieldSwiftText(
    label: String,
    message: Any,
    labelStyle: TextStyle = LocalTextStyle.current,
    messageStyle: TextStyle = LocalTextStyle.current,
    modifier: Modifier = Modifier.fillMaxWidth()
) {
    if (LocalDisplayProvider.current.resolutionDp.width > 200.dp) {
        Row(modifier) {
            Text(
                text = label,
                style = labelStyle
            )
            Space(4.dp)
            Text(
                text = message.toString(),
                textAlign = TextAlign.End,
                modifier = Modifier.fillMaxWidth()
                    .align(Alignment.CenterVertically),
                style = messageStyle
            )
        }
    } else {
        Column(modifier) {
            Text(
                text = label,
                style = labelStyle
            )
            Text(
                text = message.toString(),
                textAlign = TextAlign.End,
                modifier = Modifier.fillMaxWidth(),
                style = messageStyle
            )
        }
    }

}